import { AgGridReact } from "@jsq/ds/core";
import { ClientTemplateRow } from "../../types";
import { SkeletonLoaderCell } from "../SkeletonLoaderCell";

export const SkeletonOrValueCell = (
  params: AgGridReact.CustomCellRendererProps<ClientTemplateRow>,
): React.ReactNode | string => {
  if (params.data?.isSkeletonRow) {
    return <SkeletonLoaderCell />;
  }
  return String(params.valueFormatted ?? params.value ?? "--");
};
